<template lang="html">
  <div>
   <div class="article_header_top">
      <van-nav-bar
        :title="repliesAndviews.title"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="caricle_content">
       <h1>{{repliesAndviews.title}}</h1>
      <div class="top_num"><span>作者：{{ArticleData.authoras}}</span><span>阅读：{{repliesAndviews.views}}</span><span>评论：{{repliesAndviews.replies}}</span></div>
      <div class="article_cont_box">
        <p v-html="ArticleData.message"></p>
        <span class="edit_btn" v-show="uid==ArticleData.uid" @click="toEdit">编辑</span>
      </div>
    </div>
    <div class="right_content">
      <ul>
        <li v-for="(item, index) in commendList" :key="index">
          <div class="right_cont_left">
            <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.authorid}&size=middle`" alt="">
          </div>
          <div class="right_cont_right">
            <h2>{{item.author}}</h2><span>发表于<span v-html="item.dateline"></span></span>
            <div class="quote" v-html="item.message"></div>
          </div>
        </li>
      </ul>
      <span class="loadMores" @click="articleLoadMore" v-show="repliesAndviews.totalpage != null">{{commendLoadmoreText}}</span>
      <div class="comment_box">
        <input class="com_input" v-model="commendMsg" type="text" name="" value="" placeholder="写评论...">
        <span class="subimt" @click="postCommendMsg">发布</span>
      </div>
    </div>
    <div class="_bottom_76"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { NavBar } from 'vant'
import { Toast } from 'vant'

Vue.use(Toast)
Vue.use(NavBar)
export default {
  data() {
    return {
      ArticleData: [],
      repliesAndviews: [],
      commendList: [],
      commendPage: 1,
      commendLoadmoreText: '点击加载更多',
      commendMsg: '',
      uid:'',
      fid:0,
    }
  },
  beforeCreate() {
    Toast.loading({
      mask: false,
      message: '加载中...'
    })
  },
  created() {
    this.getArticleData()
  },
  methods: {
    onClickLeft() {
      this.$router.push('/blocklist/'+this.fid)
    },
    /*-----获取文章数据-------*/
    getArticleData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=viewthread&ordertype=1&tid='+ this.$route.params.tid+'&page=' + this.commendPage,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            if(res.data.mobile==''){
              window.location.href='/forum.php?mod=viewthread&ordertype=1&tid='+this.$route.params.tid+'&page=1'
            }
            this.ArticleData = res.data.post_content
            this.fid=res.data.fid
            this.repliesAndviews = res.data
            this.uid=res.data.uid
            for(let i in res.data.postlist){
              this.commendList.push(res.data.postlist[i])
            }
            Toast.clear()
          }
        }
      })
    },
    /*-----获取评论分页数据-------*/
    articleLoadMore() {
      this.commendPage = this.commendPage + 1
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=viewthread&ordertype=1&tid='+ this.$route.params.tid +'&page=' + this.commendPage,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            if(res.data.page <= res.data.totalpage){
              for(let j in res.data.postlist) {
                this.commendList.push(res.data.postlist[j])
              }
            }else{
              this.commendLoadmoreText = '没有更多内容了...'
            }
          }else if (res.data.code == 300) {
            this.commendLoadmoreText = res.data.msg
          }
        }
      })
    },
    toEdit(){
      if(this.uid==this.ArticleData.uid){
        this.$router.push({
          path:'/edit/'+this.$route.params.tid,
          query: {
            pid: this.ArticleData.pid
          }
        })
      }else{
        Toast('不可编辑');
      }
      
    },
    /*-----文章评论-------*/
    postCommendMsg() {
      if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/article/'+this.$route.params.tid);
      }
      const data = Qs.stringify({"replysubmit": 'replysubmit',"formhash": this.repliesAndviews.formhash,"message": this.commendMsg,"usesig": this.repliesAndviews.uid,})
      utilAxios.formpost({
        url: '/new_api.php?module=forum&mod=post&action=reply&replaysubmit=yes&fid='+ this.repliesAndviews.fid +'&tid='+this.$route.params.tid,
        method: 'POST',
        data: data,
        callback: (res) => {
          console.log(res)
          if (res.data.code == 100) {
            Toast.success(res.data.msg)
            window.location.reload();
            this.commendMsg = ''
          } else {
            Toast.fail(res.data.msg)
          }
        }
      })
    }
  }
}
</script>
<style>
  .caricle_content p img{
    max-width:100%!important;
  }
  .right_cont_right .quote img{
    max-width:100%!important;
  }
</style>
<style lang="scss" scoped>
.caricle_content{
  padding: .1rem .2rem;
  background: #fff;
  margin-top: 0.4rem;
  h1{
    font-size: .22rem;
    text-align: left;
    line-height: .35rem;
  }
  .top_num{
    text-align: left;
    line-height: .3rem;
    margin-bottom:.20rem;
    span{
      padding: 0 .2rem 0 0;
    }
  }
  .article_cont_box{
    width: 100%;
    p{
      word-break:break-all;
      word-wrap:break-word;
      line-height: .2rem;
      color:#666;
      img{
        display:block;
        width:100%;
      }
    }
    img{
      width:100% !important;
    }
  }
}
  .right_content{
    background: #fff;
    .comment_box{
      width: 90%;
      height: .35rem;
      background: #FFF;
      display: flex;
      padding: .2rem;
      position: fixed;
      left: 0;
      bottom: 0;
      border-top: 1px solid #eee;
      .com_input{
          flex: 1;
          border: none;
          border: 1px solid #999;
          border-radius: .04rem;
          padding: .05rem;
      }
      .subimt{
        width: .5rem;
        border-radius: .04rem;
        border: 1px solid #999;
        display: inline-block;
        line-height: .35rem;
        color: #999;
        text-align: center;
        margin-left: .1rem;
      }
    }
    ul{
      border-top: 1px solid #d6d6d6;
      li{
        padding: .2rem;
        // background: #FFF;
        display: flex;
        border-bottom: 1px solid #EEE;
        .right_cont_left{
          width: .9rem;
          img {
            width: .7rem;
            height: .7rem;
            border-radius: 1rem;
          }
        }
        .right_cont_right{
          flex: 1;
          h2{
            font-size: .14rem;
          }
          span{
            display: inline-block;
            padding: .1rem 0;
            color: #888;
          }
          .quote{
            line-height: .2rem;
          }
        }
      }
    }
  }
  .loadMores{
    display: block;
    width: 100%;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
  }
  ._bottom_76{
    width: 100%;
    height: .76rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Article/Article.vue